// Full-screen image viewer for journey pages. Styling mirrors the
// JourneyPanel `zoomArtwork` modal (dark slate backdrop, bordered close button).
import React, { useEffect, useState } from "react";
import {
  Modal,
  Platform,
  Pressable,
  Image,
  Text,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native";

const BACKDROP = "rgba(15,23,42,0.86)";
const MAX_FRACTION = 0.95;

export default function ImageLightbox({ visible, uri, alt, onClose, t }) {
  const translate = t || ((value) => value);
  const { width, height } = useWindowDimensions();

  useEffect(() => {
    if (!visible || Platform.OS !== "web" || typeof document === "undefined") {
      return undefined;
    }
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [visible, onClose]);

  return (
    <Modal
      visible={!!visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <Pressable
        testID="image-lightbox-backdrop"
        onPress={onClose}
        style={{
          flex: 1,
          backgroundColor: BACKDROP,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!!uri && (
          <Image
            source={{ uri }}
            accessibilityLabel={alt}
            resizeMode="contain"
            style={{
              width: width * MAX_FRACTION,
              height: height * MAX_FRACTION,
            }}
          />
        )}
        <TouchableOpacity
          onPress={onClose}
          accessibilityRole="button"
          accessibilityLabel={translate("Close")}
          style={{
            position: "absolute",
            top: 16,
            right: 16,
            width: 40,
            height: 40,
            borderRadius: 20,
            borderWidth: 1,
            borderColor: "rgba(255,255,255,0.4)",
            backgroundColor: "rgba(15,23,42,0.7)",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text style={{ color: "#fff", fontSize: 22, fontWeight: "800" }}>
            ×
          </Text>
        </TouchableOpacity>
      </Pressable>
    </Modal>
  );
}

/** An image that opens in the lightbox when pressed. */
export function ZoomableImage({ uri, alt, imageStyle, resizeMode = "contain", t }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Pressable
        testID="zoomable-image"
        onPress={() => setOpen(true)}
        accessibilityRole="button"
        accessibilityLabel={alt}
      >
        <Image
          source={{ uri }}
          accessibilityLabel={alt}
          resizeMode={resizeMode}
          style={imageStyle}
        />
      </Pressable>
      <ImageLightbox
        visible={open}
        uri={uri}
        alt={alt}
        onClose={() => setOpen(false)}
        t={t}
      />
    </>
  );
}
